import { Component, Output, EventEmitter } from '@angular/core';
import { CannabisInvitationService } from '../../services/cannabis-invitation.service';

@Component({
  selector: 'app-cannabis-invitation-dialog',
  templateUrl: './cannabis-invitation-dialog.component.html',
  styleUrls: ['./cannabis-invitation-dialog.component.scss']
})
export class CannabisInvitationDialogComponent {

  @Output() closed = new EventEmitter<void>();

  constructor(public invitationService: CannabisInvitationService) {}

  ok(): void {
    this.closed.emit();
  }
}
